import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

import Breadcrumb from "../../components/navigation/Bredcrumbs";
import TopHeadding from "../../components/layout/TopHeadding";
import StatusPopup from "../../components/popups/StatusPopup";
import { getTaxStatus, exportTaxCSV } from "../../store/slices/payrollSlice";
import { formatDate } from "../../utils/dateUtils";
import user from "../../assets/images/User.png";
import FilterTopBar from "../../components/navigation/FilterTopBar";

const TAX_STATUS_KEY = "taxStatus";
const pageSize = 10;

const getCurrentYearRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    const end = new Date(now.getFullYear(), 11, 31);
    return [start, end];
};

const TaxView = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const {
        companyId,
        startDate: initialStartDate,
        endDate: initialEndDate,
    } = location.state || {};

    // Initialize dates properly
    const [startDate, setStartDate] = useState(
        initialStartDate ? new Date(initialStartDate) : getCurrentYearRange()[0]
    );

    const [endDate, setEndDate] = useState(
        initialEndDate ? new Date(initialEndDate) : getCurrentYearRange()[1]
    );

    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const taxResponse = useSelector(
        (state) => state.payroll.entityByKey[TAX_STATUS_KEY]
    );

    const taxData = Array.isArray(taxResponse?.data)
        ? taxResponse.data
        : [];

    const loading = useSelector(
        (state) => state.payroll.entityLoadingByKey[TAX_STATUS_KEY]
    );

    const error = useSelector(
        (state) => state.payroll.entityErrorByKey[TAX_STATUS_KEY]
    );

    const exportingTaxCSV = useSelector(
        (state) => state.payroll.exportingTaxCSV
    );

    // Fetch Tax Data
    useEffect(() => {
        if (!companyId) {
            setErrorMessage("Company information missing.");
            setShowErrorPopup(true);
            return;
        }

        dispatch(
            getTaxStatus({
                params: {
                    companyIds: [companyId],
                    startDate: formatDate(startDate, "yyyy-MM-dd"),
                    endDate: formatDate(endDate, "yyyy-MM-dd"),
                },
                key: TAX_STATUS_KEY,
            })
        );
    }, [companyId, startDate, endDate, dispatch]);

    // Filter data
    const filteredData = taxData.filter((tax) => {
        if (!search) return true;
        const searchLower = search.toLowerCase();

        return (
            tax.companyName?.toLowerCase().includes(searchLower) ||
            tax.paidBy?.toLowerCase().includes(searchLower) ||
            tax.taxYear?.toString().includes(searchLower) ||
            tax.quarter?.toString().includes(searchLower) ||
            (tax.isPaid
                ? "paid".includes(searchLower)
                : "pending".includes(searchLower))
        );
    });

    const totalRecords = filteredData.length;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const paginatedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const handleExportTaxCSV = () => {
        if (!companyId) return;

        dispatch(
            exportTaxCSV({
                companyIds: [companyId],
                startDate: formatDate(startDate, "yyyy-MM-dd"),
                endDate: formatDate(endDate, "yyyy-MM-dd"),
            })
        );
    };

    const handleDateChange = ({ startDate, endDate }) => {
        setStartDate(startDate);
        setEndDate(endDate);
    };

    const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

    return (
        <div className="tax_view">
            <Breadcrumb
                items={[
                    { label: "Payroll", link: "/selectedpayroll" },
                    { label: "Tax View", active: true },
                ]}
            />

            <TopHeadding
                title="Tax View"
                showDatepicker={true}
                defaultRange={[startDate, endDate]}
                onDateChange={handleDateChange}
            />

            {loading && (
                <div className="text-center mt_50">
                    <Spinner animation="border" variant="primary" />
                </div>
            )}

            {!loading && (
                <div className="clint_table mt_30">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="white_box table_box flex-fill py_20 px_20">

                                    <FilterTopBar
                                        search={search}
                                        onSearchChange={setSearch}
                                        placeholder="Search Tax Records"
                                        showSerach={true}
                                        showFilter={false}
                                        showExport={true}
                                        customExportHandler={handleExportTaxCSV}
                                        customExportLoading={exportingTaxCSV}
                                        // onFilterChange={setFilters}
                                        exportClassName="ms-auto"
                                    />

                                    <div className="custom_table table-responsive">
                                        <div className="table-wrapper">
                                            <table className="table mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Payment Processed By</th>
                                                        <th>Company</th>
                                                        <th>Tax Year</th>
                                                        <th>Tax Quarter</th>
                                                        <th>Tax Period</th>
                                                        <th>Payment Date</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {paginatedData.length > 0 ? (
                                                        paginatedData.map(
                                                            (tax, index) => {
                                                                return <tr
                                                                    key={
                                                                        tax.payrollHeaderId ||
                                                                        index
                                                                    }
                                                                >
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="user_img mr_10">
                                                                                <img
                                                                                    src={
                                                                                        tax.companyProfile
                                                                                            ? `${BASE_URL}${tax.profile}`
                                                                                            : user
                                                                                    }
                                                                                    alt="company"
                                                                                />
                                                                            </div>
                                                                            {tax.paidBy ||
                                                                                "-"}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="user_img mr_10">
                                                                                <img
                                                                                    src={
                                                                                        tax.companyProfile
                                                                                            ? `${BASE_URL}${tax.companyProfile}`
                                                                                            : user
                                                                                    }
                                                                                    alt="company"
                                                                                />
                                                                            </div>
                                                                            {tax.companyName ||
                                                                                "-"}
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        {tax.taxYear ||
                                                                            "-"}
                                                                    </td>
                                                                    <td>
                                                                        {tax.quarter ||
                                                                            "-"}
                                                                    </td>
                                                                    <td>
                                                                        {formatDate(tax.fromDate) ||
                                                                            "-"} -
                                                                        {formatDate(tax.toDate) ||
                                                                            "-"}
                                                                    </td>
                                                                    <td>
                                                                        {tax.paidDate
                                                                            ? formatDate(
                                                                                tax.paidDate
                                                                            )
                                                                            : "-"}
                                                                    </td>
                                                                    <td>
                                                                        <div
                                                                            className={
                                                                                tax.isPaid
                                                                                    ? "active"
                                                                                    : "inactive"
                                                                            }
                                                                        >
                                                                            {tax.isPaid
                                                                                ? "Paid"
                                                                                : "Pending"}
                                                                        </div>
                                                                    </td>
                                                                </tr>;
                                                            }
                                                        )
                                                    ) : (
                                                        <tr>
                                                            <td
                                                                colSpan="6"
                                                                className="text-center"
                                                            >
                                                                No tax records
                                                                found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {totalRecords > 0 && (
                                            <div className="table_footer">
                                                <div className="footer_left">
                                                    Showing{" "}
                                                    {(currentPage - 1) *
                                                        pageSize +
                                                        1}
                                                    –
                                                    {Math.min(
                                                        currentPage * pageSize,
                                                        totalRecords
                                                    )}{" "}
                                                    of {totalRecords} entries
                                                </div>

                                                <div className="footer_right">
                                                    <button
                                                        className="page_btn"
                                                        disabled={
                                                            currentPage === 1
                                                        }
                                                        onClick={() =>
                                                            setCurrentPage(
                                                                currentPage - 1
                                                            )
                                                        }
                                                    >
                                                        ‹ Previous
                                                    </button>

                                                    {Array.from(
                                                        {
                                                            length: totalPages,
                                                        },
                                                        (_, i) => (
                                                            <button
                                                                key={i}
                                                                className={`page_btn ${currentPage ===
                                                                    i + 1
                                                                    ? "active"
                                                                    : ""
                                                                    }`}
                                                                onClick={() =>
                                                                    setCurrentPage(
                                                                        i + 1
                                                                    )
                                                                }
                                                            >
                                                                {String(
                                                                    i + 1
                                                                ).padStart(
                                                                    2,
                                                                    "0"
                                                                )}
                                                            </button>
                                                        )
                                                    )}

                                                    <button
                                                        className="page_btn"
                                                        disabled={
                                                            currentPage ===
                                                            totalPages
                                                        }
                                                        onClick={() =>
                                                            setCurrentPage(
                                                                currentPage + 1
                                                            )
                                                        }
                                                    >
                                                        Next ›
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {error && (
                <div className="text-center mt_50 text-danger">
                    Failed to load tax data.
                </div>
            )}

            <StatusPopup
                show={showErrorPopup}
                type="error"
                message={errorMessage}
                handleClose={() => setShowErrorPopup(false)}
            />
        </div>
    );
};

export default TaxView;
